import axios from "axios";
import { API_BASE_URL } from "../constants/api";
import { ACCESS_TOKEN } from "../constants/auth";

const ProfessionService = {};
ProfessionService.getProfessions = async () => {
  return axios({
    method: "get",
    url: API_BASE_URL + "/api/profession/get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};
export default ProfessionService;
